import React, { useCallback } from 'react'
import { useChannelStateContext } from 'stream-chat-react'
import IconButton from '@mui/material/IconButton'
import LinkIcon from '@mui/icons-material/Link'
import useToast from 'hooks/useToast'
import { threadPath } from '../../Phone/navigation'

// Copies a deep link to this conversation (/chat?cid=...) so it can be
// shared with other staff. The same link format is used by Slack inbox
// threads and is handled by the Chat DeepLink component.
export const useCopyConversationLink = (channel) => {
  const toast = useToast()
  const channelCid = channel?.cid

  return useCallback(async () => {
    const url = `${window.location.origin}${threadPath(channelCid)}`
    try {
      await navigator.clipboard.writeText(url)
      toast({ message: 'Link to conversation copied.' })
    } catch (err) {
      toast({ message: err.message, severity: 'error' })
    }
  }, [channelCid, toast])
}

const ShareButton = () => {
  const { channel } = useChannelStateContext()
  const copyLink = useCopyConversationLink(channel)

  if (!channel?.cid) return null

  return (
    <IconButton
      title="Copy link to conversation"
      sx={{ marginLeft: 2 }}
      onClick={copyLink}
    >
      <LinkIcon />
    </IconButton>
  )
}

export default ShareButton
